import React from "react";
import { useLocation } from "react-router-dom";
import ReunionGameHome from "./game/ReunionGameHome";

// Original file imported `TinyThink` from "../../../iqgames/tinythink/TinyThinkHome",
// which doesn't exist anywhere in the repo (see Phase 1 review). Replaced
// with the real ReunionGameHome engine built in Phase 2.

const ReunionLive = () => {
  const location = useLocation();
  const event = location.state?.event;

  if (!event?._id) {
    return (
      <div className="min-h-screen flex items-center justify-center text-red-300 text-center px-4">
        No event context found — please join again from the Reunion entry
        screen.
      </div>
    );
  }

  return <ReunionGameHome eventId={event._id} />;
};

export default ReunionLive;
